export default "__VITE_ASSET__De6CV01E__";